export default { sha: '8d7d68f1738d9eb8da82cc52192686be11d612f0', buildNumber: 'undefined' }
